<big-ui-modal-frame
    *transloco="let t; prefix: 'uiModalInfo'"
    [closeBtnTitle]="t('closeOverlayBtn')"
    (closeModal)="popoverRef.close({ leaveForm: false })">
    <ng-container title>{{ title }}</ng-container>
    <ng-container content>
        <div [innerHTML]="description | sanitize: securityContext"></div>
        @if (link) {
            <big-ui-link
                [href]="link.href"
                (click)="onLinkClick()"
                [target]="link.target">
                <span>{{ link.title }}</span>
            </big-ui-link>
        }
    </ng-container>
</big-ui-modal-frame>
